import AgricultureIcon from '@mui/icons-material/Agriculture';
import LocalFloristIcon from '@mui/icons-material/LocalFlorist';
import TimelineIcon from '@mui/icons-material/Timeline';
import {Box, Button, type SxProps, Typography} from '@mui/material';
import {useNavigate} from 'react-router-dom';
import Header from '@/components/Header';

const MainMenuPage = () => {
  const navigate = useNavigate();

  const handleFieldMapClick = () => {
    navigate('fieldMap');
  };

  const handleTrackMapClick = () => {
    navigate('trackMap');
  };

  const handleFleetMapClick = () => {
    navigate('fleetMap');
  };

  return (
    <Box sx={styles.container}>
      <Header />
      <Typography variant="h3" component="h1" sx={styles.title}>
        Demo Viewer
      </Typography>

      <Box sx={styles.buttonsContainer}>
        <Box sx={styles.buttonGroup}>
          <Button variant="contained" onClick={handleFieldMapClick} sx={styles.squareButton}>
            <LocalFloristIcon sx={styles.icon} />
            Field Map
          </Button>
          <Typography variant="body1" color="text.secondary" sx={styles.description}>
            View and manage field surveys
          </Typography>
          <Button variant="text" onClick={handleFieldMapClick} sx={styles.textButton}>
            Open Field Map →
          </Button>
        </Box>

        <Box sx={styles.buttonGroup}>
          <Button variant="contained" onClick={handleTrackMapClick} sx={styles.squareButton}>
            <TimelineIcon sx={styles.icon} />
            Track Map
          </Button>
          <Typography variant="body1" color="text.secondary" sx={styles.description}>
            See the historic movements of your devices
          </Typography>
          <Button variant="text" onClick={handleTrackMapClick} sx={styles.textButton}>
            Open Track Map →
          </Button>
        </Box>

        <Box sx={styles.buttonGroup}>
          <Button variant="contained" onClick={handleFleetMapClick} sx={styles.squareButton}>
            <AgricultureIcon sx={styles.icon} />
            Fleet Map
          </Button>
          <Typography variant="body1" color="text.secondary" sx={styles.description}>
            View live positions of your devices
          </Typography>
          <Button variant="text" onClick={handleFleetMapClick} sx={styles.textButton}>
            Open Fleet Map →
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default MainMenuPage;

const styles: Record<string, SxProps> = {
  container: {
    minHeight: '100dvh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 4,
    py: 4,
    width: '100%',
  },
  title: {
    mt: 2,
    fontWeight: 600,
    textAlign: 'center',
    mb: {xs: 0, md: 4},
    fontSize: {
      xs: '1.5rem', // h5
      md: '3rem', // h3
    },
  },
  buttonsContainer: {
    display: 'flex',
    flexDirection: {xs: 'column', md: 'row'},
    gap: 4,
    width: '100%',
    maxWidth: 1400,
  },
  buttonGroup: {
    flex: {md: 1},
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 1,
    px: 4,
  },
  icon: {fontSize: {xs: 80, md: 120}},
  squareButton: {
    width: '100%',
    height: {xs: 125, md: 300},
    display: 'flex',
    flexDirection: {xs: 'row', md: 'column'},
    gap: 2,
    fontSize: '1.5rem',
    fontWeight: 600,
    textTransform: 'none',
    borderRadius: 2,
    boxShadow: 3,
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: 6,
    },
  },
  description: {
    textAlign: 'center',
    fontSize: {xs: '0.75rem', md: '1rem'},
  },
  textButton: {
    textTransform: 'none',
  },
};
